import type React from 'react'

/** Enter on an offset input commits by blurring it, but only when its value is valid. An invalid
 *  value must stay in place with its error visible until the user manually corrects it or
 *  navigates elsewhere (real blur) — Enter only commits when the value is already valid. Matches
 *  the Font Size input's behavior (`fontSizeError`), which never force-blurs on Enter at all. */
export function handleOffsetEnterKey(e: React.KeyboardEvent<HTMLInputElement>, hasError: boolean) {
  if (e.key === 'Enter') {
    e.preventDefault()

    if (hasError) return
    ;(e.target as HTMLInputElement).blur()
  }
}
